import MaintenanceDetailGeneralInfo from "./MaintenanceDetailGeneralInfo";
export default MaintenanceDetailGeneralInfo;
